var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container"},[_c('launcher'),_c('side-nav'),_c('section',{staticClass:"app-main"},[_c('div',{ref:"appBody",staticClass:"main-body"},[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }